export const formatCinemaData = (cinema) => ({
    id: cinema.id,
    name: cinema.name,
    address: cinema.address,
    url: cinema.url,
    allocine_id: cinema.allocine_id,
    coordinates: cinema.coordinates || {
        lat: null,
        lon: null
    }
});

export const formatMovieData = (movie) => {
    const codeToType = {
        l: "local",
        d: "local",
        o: "original",
        m: "multiple"
    };

    const actors = movie.c
        ? Object.values(movie.c).map(actor => ({
            id: actor.i,
            firstName: actor.fn,
            lastName: actor.ln
        }))
        : [];

    const genres = movie.g
        ? Object.values(movie.g).map(genre => genre)
        : [];

    const showtimes = Object.fromEntries(
        Object.entries(movie.st).map(([cinemaId, versions]) => {
            const grouped = {
                local: [],
                original: [],
                multiple: []
            };

            // Process each version (l, m, etc.)
            for (const [code, times] of Object.entries(versions)) {
                const type = codeToType[code] || code;
                
                // Add each time object to the appropriate group
                times.forEach(timeObj => {
                    if (timeObj && timeObj.time) {
                        grouped[type].push({
                            time: timeObj.time,
                            date: timeObj.date
                        });
                    }
                });
            }

            // Sort times within each group
            for (const type of Object.keys(grouped)) {
                grouped[type].sort((a, b) => {
                    // First sort by date
                    const dateCompare = a.date.localeCompare(b.date);
                    if (dateCompare !== 0) return dateCompare;
                    // Then sort by time
                    return a.time.localeCompare(b.time);
                });
            }

            return [cinemaId, grouped];
        })
    );

    return {
        id: movie.i,
        title: movie.t,
        originalTitle: movie.ot,
        description: movie.s,
        poster: movie.p,
        firstReleaseDate: movie.frd,
        director: {
            firstName: movie.d.fn,
            lastName: movie.d.ln
        },
        actors: actors,
        genres: genres,
        duration: movie.rt,
        showtimes: showtimes
    };
};

